module.exports = __webpack_public_path__ + "fonts/01b142f405ed5d6d8a0c9bcf7fd704c1.woff";